const ProvidersKeys = {
    SOLUTIONS_DATA: 'solutions_data',
    TRANSLATIONS: 'translations',
    CLUSTER_CONFIG: 'cluster_config'
}

module.exports = ProvidersKeys;